import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=45b070ae"
import script from "./Header.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./Header.vue?vue&type=script&charset=utf-8&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports